import type { Signal } from '@angular/core';
import type { EntityCrudStrategy } from './entity-edit.types';
import type { ResourceFactory } from '../services/api-resource/resource.types';

export class ApiResourceCrudStrategy<TEntity, TPayload> implements EntityCrudStrategy<TEntity, TPayload> {
  constructor(private readonly resourceFactory: ResourceFactory<TEntity, TPayload, TPayload>) {}

  load(idSignal: Signal<string | null>) {
    return this.resourceFactory({ id: idSignal });
  }

  create(payload: TPayload) {
    return this.resourceFactory.create(payload);
  }

  update(id: string, payload: TPayload) {
    return this.resourceFactory.update(id, payload);
  }

  delete(id: string) {
    return this.resourceFactory.delete(id);
  }
}
